/**
 * contiene la información para el manejo de documentos.
 */
export const defaultNfpa = () => {
    return {
        id: 3,
        rojo: '',
        azul: '',
        amarillo: '',
        blanco: ''
    }
}

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    selectedNfpa: defaultNfpa(),
    optrojo: [],
    optazul: [],
    optamarillo: [],
    optblanco: [
        { value: '', text: '' }
    ]
}